import StickyHeader from '../__header/StickyHeader'
import MegaMenu from '../__header/MegaMenu'
import MobileHeader from '../__header/mobileHeader'
import mirrorHover from '../__utils/mirrorHover'
import smoothScroll from '../__utils/smoothScroll'
import vhUnit from '../__utils/vhUnit'
import stopAnimation from '../__utils/stopAnimation'
import HeaderSearch from '../__header/HeaderSearch'

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js')
        StickyHeader.init()
        MegaMenu.init()
        MobileHeader.init()
        HeaderSearch.init()
        mirrorHover()
        smoothScroll()
        vhUnit()
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded')
        vhUnit()
        StickyHeader.resize()
    },
    resized() {
        MobileHeader.resized()
        StickyHeader.scroll()
        StickyHeader.resize()
        vhUnit()
        stopAnimation()
    },
    scrolled() {
        StickyHeader.scroll()
    },
    keyDown(e) {

    },
	gformRender() {
	},
    mouseUp(e) {
        MobileHeader.hideOutsideClick(e)
    },
}
export default controller
